import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Heart, ArrowUpRight } from 'lucide-react';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="relative overflow-hidden pb-20 md:pb-0" data-testid="footer">
      <div className="glass-card-strong border-t-0 rounded-t-[1.5rem] mx-3 md:mx-0 md:rounded-none">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-8 md:py-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
            {/* Brand */}
            <div className="md:col-span-5">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-[#E8A0B8] to-[#C5DB7B] flex items-center justify-center">
                  <span className="text-white text-[10px] font-bold font-['DM_Sans']">S</span>
                </div>
                <span className="font-['Cormorant_Garamond'] text-xl font-medium text-[#2C2A29]">Seikat</span>
              </div>
              <p className="text-[13px] text-[#6B655F] leading-relaxed max-w-sm">
                {t('footer.tagline')}
              </p>
            </div>

            {/* Links */}
            <div className="md:col-span-3">
              <h4 className="overline mb-3">{t('footer.quick_links')}</h4>
              <div className="space-y-1.5">
                {[
                  { to: '/catalog', label: t('nav.catalog') },
                  { to: '/memory-bouquet', label: t('nav.memory_bouquet') },
                  { to: '/gallery', label: t('nav.gallery') },
                  { to: '/about', label: t('nav.about') },
                ].map(link => (
                  <Link key={link.to} to={link.to} className="flex items-center gap-1 text-[13px] text-[#6B655F] hover:text-[#D4859B] transition-colors group">
                    {link.label}
                    <ArrowUpRight size={11} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                ))}
              </div>
            </div>

            {/* Contact */}
            <div className="md:col-span-4">
              <h4 className="overline mb-3">{t('footer.contact')}</h4>
              <div className="space-y-1.5 text-[13px] text-[#6B655F]">
                <p>hello@seikat.id</p>
                <p>+62 812-3456-7890</p>
                <p>Jakarta, Indonesia</p>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-4 border-t border-white/30 flex flex-col md:flex-row items-center justify-between gap-2">
            <p className="text-[10px] text-[#6B655F]/50">
              &copy; {new Date().getFullYear()} Seikat. {t('footer.rights')}
            </p>
            <div className="flex items-center gap-1 text-[10px] text-[#6B655F]/50">
              Made with <Heart size={9} className="text-[#E8A0B8] mx-0.5" fill="#E8A0B8" /> in Jakarta
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
